import { createClient } from '@supabase/supabase-js';

const SUPA_URL  = 'https://pgjncthsfxsylmvkgibx.supabase.co';
// Use env key at build time; fall back to the known-good JWT anon key
const SUPA_ANON =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBnam5jdGhzZnhzeWxtdmtnaWJ4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcxMDEwMTEsImV4cCI6MjA5MjY3NzAxMX0.PDtIhTOuZNnwOqNkdOD8eTC6SCXdlPT5H7vrcU30UXk';

export const supabase = createClient(SUPA_URL, SUPA_ANON);

export type Review = {
  id: string;
  user_id: string;
  meal_name: string;
  store_name: string | null;
  rating: number;
  comment: string | null;
  photo_url: string | null;
  user_name: string | null;
  user_avatar: string | null;
  created_at: string;
};
